// Sistema de cores dos relatorios — IDV Smart² aplicada (SMART2-APLICAR-IDV.md).
// Pele = tokens do CRM (superficies/textos via classes n:), alma = IDV:
// semanticas fixas e regra de ouro — metrica NUNCA usa o burgundy primary.
//   verde  = conversao/venda/ganho        vermelho = perda/custo/estouro
//   ambar  = tempo/atencao/pendente       azul-info = volume/neutro
//   dourado = destaque especial (hero, podium)
export const REPORT_COLORS = {
  PRIMARY: '#6b8aaf', // volume/totais (info da IDV — burgundy e proibido em metrica)
  SECONDARY: '#a08968', // dourado escuro — series secundarias
  POSITIVE: '#22c55e', // conversao, venda, ganho, resolvido
  NEGATIVE: '#ef4444', // perda, churn, atraso, SLA estourado
  WARNING: '#f59e0b', // pendente, em andamento, atencao
  NEUTRAL: '#9a8e88', // inativo, sem dado (warm gray da IDV)
  INFO: '#6b8aaf', // informacional
  GOLD: '#c4a882', // accent da marca — destaque especial
  BRAND: '#441210', // burgundy — SO navegacao/decoracao, nunca metrica

  // Paleta multi-categoria (donuts, series) — harmonizada com a IDV
  PALETTE: [
    '#6b8aaf', // info
    '#22c55e', // positive
    '#f59e0b', // warning
    '#c4a882', // gold
    '#7a2f2b', // burgundy claro (categoria, nao metrica)
    '#4ade80', // positive light
    '#d4be9e', // gold light
    '#8fa8c4', // info light
    '#a08968', // gold dark
    '#ef4444', // negative (ultimo — vermelho implica "ruim")
  ],

  // Aliases semanticos
  WON: '#22c55e',
  LOST: '#ef4444',
  OPEN: '#6b8aaf',
  PENDING: '#f59e0b',
  RESOLVED: '#22c55e',
  OVERDUE: '#ef4444',
};

// Barra de categoria dos KPI cards (assinatura visual do BI Smart²):
// o gestor aprende o codigo uma vez e escaneia qualquer tela.
export const KPI_CATEGORIES = {
  revenue: '#22c55e', // receita/conversao
  risk: '#ef4444', // perda/risco
  time: '#f59e0b', // tempo/atencao
  volume: '#6b8aaf', // volume/neutro
  highlight: '#c4a882', // destaque especial (hero)
};

// Familia steel blue (azul oficial do BI Smart²) — unica familia de azul
// permitida em dados: base #6B8AAF, claro #8FA8C4, escuro #46627F.
export const STEEL_BLUE = {
  base: '#6B8AAF',
  light: '#8FA8C4',
  dark: '#46627F',
};

// Rampas sequenciais dos heatmaps (menos -> mais), derivadas da IDV.
// blue = volume (steel do BI), green = desfecho positivo, amber = atencao.
export const HEATMAP_RAMPS = {
  blue: {
    light: ['#F5F8FB', '#DEE7F0', '#B9CADD', '#8FA8C4', '#6B8AAF', '#44607E'],
    dark: ['#1D2A38', '#2F4459', '#46627F', '#6B8AAF', '#8FA8C4', '#A7BDD3'],
  },
  green: {
    light: ['#F0FBF4', '#D3F2DF', '#9FE3BC', '#4ADE80', '#22C55E', '#166534'],
    dark: ['#14432A', '#166534', '#178A43', '#22C55E', '#4ADE80', '#A7F3C9'],
  },
  amber: {
    light: ['#FEF7E8', '#FDE8C0', '#FBCF7C', '#F59E0B', '#D97706', '#92400E'],
    dark: ['#2D2305', '#4A3A08', '#92400E', '#D97706', '#F59E0B', '#FCD34D'],
  },
};
